<!--
// app/components/Shared/HeaderBannerTitle.vue
-->
<script setup lang="ts">
import { useWebContext } from "~/composables/webContext";

type Props = {
  title: string;
  subtitle?: string;
  isMercatoLanding?: boolean;
};

defineProps<Props>();

const { isKings } = useWebContext();
</script>

<template>
  <div class="kql-centered-title-container">
    <div class="text-center flex-initial md:min-w-fit px-4 py-4 md:py-6">
      <h1 class="font-kings uppercase text-5xl md:text-7xl text-primary rtl:font-bold">
        {{ title }}
      </h1>
      <component :is="isMercatoLanding ? 'p' : 'h2'" v-if="!!subtitle" class="md:text-xl mt-1">{{
        subtitle
      }}</component>
      <slot name="extraContent"></slot>
    </div>
  </div>
</template>

<style scoped></style>
